var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize.initial",
          value: _vm.handleResize,
          expression: "handleResize",
          modifiers: { initial: true }
        }
      ],
      attrs: {
        role: "dialog",
        "aria-label": "modal",
        "aria-describedby": "content-modal_aria"
      }
    },
    [
      _c("content-modal-header", {
        attrs: {
          options: _vm.headerOptions,
          modalName: _vm.modalName,
          id: "content-modal_aria",
          tabindex: "0"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-main-content", class: _vm.displayType() },
        [
          _vm.contentComponent
            ? _c(
                _vm.contentComponent,
                _vm._b(
                  { tag: "component", on: { changeTitle: _vm.changeTitle } },
                  "component",
                  _vm.contentProperties,
                  false
                )
              )
            : _c("div", { staticClass: "has-text-centered template-section" }, [
                _c("h3", { staticClass: "is-size-3" }, [
                  _vm._v(_vm._s(_vm.contentTemplate))
                ])
              ])
        ],
        1
      ),
      _vm._v(" "),
      _c("content-modal-footer", { attrs: { options: _vm.footerOptions } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c931880", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c931880","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global-modal/ContentModal.vue
// module id = null
// module chunks = 